import { ComponentProps } from 'react'

interface Props extends ComponentProps<'svg'> {
  color?: string
}

export const IconSaveAsDraft = ({ color = 'currentColor', ...props }: Props) => (
  <svg width="14" height="18" viewBox="0 0 14 18" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4859 3.44531L10.4271 0.495703C10.099 0.179297 9.65417 0 9.19115 0H1.75C0.783854 0.00351563 0 0.759375 0 1.69102V16.316C0 17.2477 0.783854 18.0035 1.75 18.0035H12.25C13.2161 18.0035 14 17.2477 14 16.316V4.64062C14 4.19414 13.8141 3.76172 13.4859 3.44531ZM12.1078 4.50352H9.33333V1.82812L12.1078 4.50352ZM1.75 16.316V1.69102H7.58333V5.34727C7.58333 5.81484 7.97344 6.19102 8.45833 6.19102H12.25V16.316H1.75ZM7.69635 8.23359L9.4026 9.87891C9.47552 9.94922 9.47552 10.0617 9.4026 10.132L5.22812 14.1574L3.47083 14.3473C3.2375 14.3719 3.03698 14.182 3.0625 13.9535L3.25937 12.259L7.43385 8.23359C7.50677 8.16328 7.62344 8.16328 7.69635 8.23359ZM10.7224 8.85938L10.0115 9.54492C9.93854 9.61523 9.82187 9.61523 9.74896 9.54492L8.04271 7.89961C7.96979 7.8293 7.96979 7.7168 8.04271 7.64648L8.75365 6.96094C9.04167 6.6832 9.50833 6.6832 9.79635 6.96094L10.7224 7.85391C11.0104 8.13164 11.0104 8.58164 10.7224 8.85938Z"
      fill={color}
    />
  </svg>
)
